const config = {
    adminUsername: "admin",  // اسم المستخدم
    adminPassword: "admin",  // كلمة المرور
  };
  
  export default config;
  